import React from 'react';
import { Grid, Layout } from 'antd';
import { AppHeader } from './AppHeader';
import { DevelopmentEnvironmentBanner } from './DevelopmentEnvironmentBanner';

const { Content } = Layout;
const { useBreakpoint } = Grid;

export interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

export const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({ children }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader />
      <Layout style={{ display: 'flex', flexDirection: 'column' }}>
        <Content style={{ padding: isMobile ? '12px 8px' : '24px', flex: 1 }}>
          {children}
        </Content>
        <DevelopmentEnvironmentBanner />
      </Layout>
    </Layout>
  );
};
